import { Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { RateBreakout } from '../../../../types/searchAvailability'

type Props = {
  className?: string
  rateBreakouts?: RateBreakout[]
}

const DISPLAY_RATE_TYPES = ['DISPLAY_RATE']

export const DisplayRateBreakouts: React.FC<Props> = ({
  className,
  rateBreakouts
}) => {
  const displayRates = rateBreakouts?.filter(
    (b) => DISPLAY_RATE_TYPES.includes(b.rateBreakoutType) && !!b.currency
  )

  if (!displayRates?.length) {
    return null
  }

  return (
    <>
      {displayRates.map((displayRate, i) => (
        <Typography key={i} variant="caption" className={className}>
          {`${getTranslate('Display Rate')}: ${addCommaToPrice(
            displayRate.amount
          )} ${getTranslate(displayRate.currency || '')}`}
        </Typography>
      ))}
    </>
  )
}
